/*!

=========================================================
* Argon Design System React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
/*eslint-disable*/
import React from "react";
import { withNamespaces } from "react-i18next";
import { Link } from "react-router-dom";
// reactstrap components
import {
  Button,
  NavItem,
  NavLink,
  Nav,
  Container,
  Row,
  Col,
  UncontrolledTooltip
} from "reactstrap";

class SimpleFooter extends React.Component {
  render() {
    const { t } = this.props;
    return (
      <>
        <footer style={{ backgroundColor: "#fff" }} className="footer">
          <Container>
            <Row className="align-items-center justify-content-md-between">
              <Col xs="6" className="text-left">
                <div className="copyright">
                  © {new Date().getFullYear()}{" "}
                  <a
                    href={"/"}
                  >
                    Vivo Max Pro
                  </a>
                  .
                </div>
              </Col>
              <Col xs="6">
                <Nav className="nav-footer text-right justify-content-end">
                  {/* {<NavItem>
                    <NavLink
                      tag={Link}
                      to={"https://facebook.com"}
                    >
                      <i className="fa fa-facebook-square" /> Facebook
                    </NavLink>
                  </NavItem>} */}
                  <Button
                    className="btn-icon-only rounded-circle ml-1"
                    color="facebook"
                    href="https://www.facebook.com/vivomaxpro"
                    id="tooltip837440414"
                    target="_blank"
                  >
                    <span className="btn-inner--icon">
                      <i className="fa fa-facebook-square" />
                    </span>
                  </Button>
                  <UncontrolledTooltip delay={0} target="tooltip837440414">
                    {t("LikeUs")}
                  </UncontrolledTooltip>
                  <Button
                    className="btn-icon-only rounded-circle ml-1"
                    color="instagram"
                    href="https://www.instagram.com/vivomaxpro"
                    id="tooltip837440415"
                    target="_blank"
                  >
                    <span className="btn-inner--icon">
                      <i className="fa fa-instagram" />
                    </span>
                  </Button>
                  <UncontrolledTooltip delay={0} target="tooltip837440415">
                    {t("FollowUs")}
                  </UncontrolledTooltip>
                </Nav>
              </Col>
            </Row>
          </Container>
        </footer>
      </>
    );
  }
}

export default withNamespaces()(SimpleFooter);
